<template>
  <div class="tw-flex tw-flex-col tw-pb-4 tw-px-4">
    <div
      class="tw-h-4 tw-bg-sf-snow-lighter tw-w-full tw-top-0 tw-sticky tw-z-50"
    />
    <div class="tw-flex tw-flex-col tw-gap-4">
      <InboxNotificationGroup
        v-if="!!groupedCommunication[COMPANY_CATEGORY]"
        :name="I18n.t('company.start')"
        :show-mark-as-read="false"
      >
        <template #default>
          <template
            v-for="comm in groupedCommunication[COMPANY_CATEGORY][
              CLIENT_OVERVIEW_SECTION
            ]"
            :key="`${comm.kind}-${comm.id}`"
          >
            <RemarkV2
              v-if="comm.kind === 'remark-card'"
              :remark="comm"
              show-context-btn
              show-tags
              part-of="inbox"
            />
            <NotificationContent
              v-else
              type="CheckList"
              :communication-item="comm"
            />
          </template>
        </template>
      </InboxNotificationGroup>
      <InboxNotificationGroup
        v-for="section in menuSections"
        :key="section.categoryId"
        :name="section.categoryName"
        :show-mark-as-read="false"
      >
        <template #default>
          <template
            v-for="item in sectionItems[section.categoryId]"
            :key="`${section.categoryName}-${item.name}`"
          >
            <template
              v-for="comm in groupedCommunication[section.categoryId][
                item.name
              ]"
              :key="`${comm.kind}-${comm.id}`"
            >
              <RemarkV2
                v-if="comm.kind === 'remark-card'"
                :remark="comm"
                show-context-btn
                show-context
                show-tags
                part-of="inbox"
              />
              <NotificationContent
                v-else
                type="CheckList"
                :communication-item="comm"
              />
            </template>
          </template>
        </template>
      </InboxNotificationGroup>
    </div>
  </div>
</template>

<script setup>
import InboxNotificationGroup from '@app/application/communication/screens/inbox/components/inbox-notification-group.vue'
import RemarkV2 from '@app/shared/vue/components/molecules/remark-v2/remark-v2.vue'
import NotificationContent from '@app/application/communication/screens/inbox/components/notification-content.vue'
import useI18n from '@app/shared/vue/composables/use-I18n'
import {
  CLIENT_OVERVIEW_SECTION,
  COMPANY_CATEGORY,
} from '@app/application/communication/screens/inbox/store/utils'
import useGroupedFilteredCommunications from '@app/application/communication/screens/inbox/composables/use-grouped-filtered-communications'

const I18n = useI18n()

const { groupedCommunication, sectionItems, menuSections } =
  useGroupedFilteredCommunications()
</script>

<style scoped>
.inbox-notification-group {
  --sf-inbox-notification-group-sticky-offset: 16px;
}
</style>
